import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// ��������ǉ�
import firebase from './firebase' // �ǋL

Vue.use(firebase) //�ǋL

window.console.log("main.ts 1.");
// �����܂Œǉ�

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
